// CallSignalRListener.tsx

import { useEffect, useLayoutEffect, useRef } from "react";
import * as signalR from "@microsoft/signalr"; // FIXED: use * as signalR
import { useNotifications } from "./NotificationProvider";
import { useAuth } from "../firebase/AuthProvider";
import { useNavigate } from "react-router-dom";
import { CallActionRequest, LobbyState } from "../interfaces/videocallDtos/videoCall";
import { NofifyForRingingOffDto, ReceiveGroupCallInviteResponse } from "../interfaces/videoHubResponse/videoHubResponse";
import { RejectVideoCallAsync } from "../services/videoService/VideoService";

import { encodeLobbyStateToToken } from "../utilities/lobbyStateToken";

const CallSignalRListener = () => {
    const { notifyForCall, hideCallBanner } = useNotifications();
    const { currentUser } = useAuth(); // assuming this provides auth info
    const navigate = useNavigate();
    const notificationHandlers = useRef({ notifyForCall, hideCallBanner, navigate });
    useLayoutEffect(() => {
        notificationHandlers.current = { notifyForCall, hideCallBanner, navigate };
    }, [notifyForCall, hideCallBanner, navigate]);


    useEffect(() => {
const rejectVideoCall = (roomId: string) => {
        currentUser?.getIdToken().then((token) => {
            if (token) {
                const payload: CallActionRequest = {
                    roomId: roomId
                }
                RejectVideoCallAsync(token, payload).then((res) => {

                }).catch((err) => {

                })
            }
        })
    }

        if (!currentUser) return; // Wait for user to be available

        const connection = new signalR.HubConnectionBuilder()
            .withUrl(`${process.env.REACT_APP_API_BASE_URL}/videoHub`, {
                accessTokenFactory: async () => {
                    // Get the token from Firebase Auth or wherever you store it
                    const token = await currentUser.getIdToken(true); // Firebase example
                    return token;
                },
            })
            .withAutomaticReconnect()
            .build();

        // for calling notification
        connection.on(
            "ReceiveGroupCallInvite",
            (hubResponse: ReceiveGroupCallInviteResponse) => { // conversation id may be calendereventId, conversationId
                console.log("Hub Data : ", hubResponse);

                // Never ring/prompt a user for a room they are already viewing.
                // This protects an active participant from duplicate/stale invite events
                // when another participant joins the same ongoing conversation call.
                const currentPath = window.location.pathname.toLowerCase();
                const roomPath = String(hubResponse.roomId || "").toLowerCase();
                const alreadyInThisRoom = Boolean(roomPath) && (
                    currentPath.includes(`/room/${roomPath}`) ||
                    currentPath.includes(`/external/room/${roomPath}`) ||
                    currentPath.includes(`/lobby/${roomPath}`)
                );

                if (alreadyInThisRoom) {
                    notificationHandlers.current.hideCallBanner();
                    return;
                }
                
                const states: LobbyState = {
                    calenderEventId: hubResponse.calenderEventId,
                    targetUserId: null,
                    relatedChatConversationId: hubResponse.conversationId?.toString(),
                    isPublisher: false,
                    isOneToOneCall: false
                }

                // The listener remains globally active, while the heavier lobby
                // UI is route-split. Start fetching that route as soon as the
                // invitation arrives so it is usually ready before Accept.
                void import("../components/components/sproutHub/Lobby");

                notificationHandlers.current.notifyForCall(hubResponse, () => {
                    console.log("Call accepted");
                    const stateToken = encodeLobbyStateToToken(states);
                    notificationHandlers.current.navigate(`/lobby/${hubResponse.roomId}?state=${encodeURIComponent(stateToken)}`);
                }, () => {
                    connection.invoke("RejectCall", hubResponse.roomId, hubResponse.callerId, currentUser.uid, hubResponse?.conversationId || 0)
                        .then(() => {
                            console.log("Call rejection sent to hub.");
                        })
                        .catch((err) => {
                            console.error("Error invoking RejectCall:", err);
                        });
                    rejectVideoCall(hubResponse.roomId);
                    console.log("Call rejected");
                });
            }
        );

        // NEW: Listen for NotifyCallRingingOff to dismiss the call banner
        connection.on(
            "NotifyCallRingingOff",
            (data:NofifyForRingingOffDto) => {
                console.log("Notification recived", data);
                
                // You may need to implement a dismissCallNotification method in your notification context
                notificationHandlers.current.hideCallBanner();
            }
            
        );

        // NEW: Listen when call is answered on another device
            connection.on(
                "CallAnswered",
                (data: any) => {
                    console.log("CallAnswered received", data);
                    // Hide banner + stop sound
                    notificationHandlers.current.hideCallBanner();
                }
            );

            connection.on(
            "CallRejected",
            (data: any) => {
                console.log("CallRejected received", data);
                notificationHandlers.current.hideCallBanner();
            }
        );
        connection
            .start()
            .then(() => {
                console.log("✅ SignalR connected");
                console.log("Connection id : ", connection);
                
            })
            .catch((err) => {
                console.error("❌ SignalR connection error:", err);
            });

        // Cleanup on unmount or dependency change
        return () => {
            connection.stop();
        };
    }, [currentUser]);




    return null;
};


export default CallSignalRListener;
